import React, {useState, useEffect, useContext} from 'react';
import { UserContext, WorkspaceContext, OrgContext } from '../../objects/Context';
import './Settings.css';
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen';
import { useNavigate, useLocation } from 'react-router-dom';
import ErrorHandler from '../../components/ErrorHandler/ErrorHandler';
import SettingsMenu from './SettingsMenu/SettingsMenu.jsx';

import ProfileSettings from './SettingComponents/ProfileSettings';
import OrgGeneralSettings from './SettingComponents/OrgGeneralSettings';
import OrgBrandingSettings from './SettingComponents/OrgBrandingSettings';
import OrgMembersSettings from './SettingComponents/OrgMembersSettings';
import SubscriptionSettings from './SettingComponents/SubscriptionSettings';
import WorkspaceGeneralSettings from './SettingComponents/WorkspaceGeneralSettings';
import InviteClientsSettings from './SettingComponents/InviteClientsSettings';

function Settings() {
    const { user } = useContext(UserContext);
    const { workspace } = useContext(WorkspaceContext);
    const { org } = useContext(OrgContext);
    const navigate = useNavigate();
    const location = useLocation();
   
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [selectedMenuItem, setSelectedMenuItem] = useState('profile');

    // Handle tab selection from navigation state or URL query params
    useEffect(() => {
        if (location.state?.selectedMenuItem) {
            setSelectedMenuItem(location.state.selectedMenuItem);
            navigate(location.pathname, { replace: true, state: {} });
        } else {
            const params = new URLSearchParams(location.search);
            const tab = params.get('tab');
            if (tab) {
                setSelectedMenuItem(tab);
                // Clean URL params but preserve checkout param for SubscriptionSettings
                if (!params.get('checkout')) {
                    navigate(location.pathname, { replace: true });
                }
            }
        }
    }, [location.state, location.search, navigate, location.pathname]);

    const renderSettingsContent = () => {
        const commonProps = {
            user,
            workspace,
            org,
            setLoading,
            setError
        };

        switch (selectedMenuItem) {
            case 'profile':
                return <ProfileSettings {...commonProps} />;
            case 'org-general':
                return <OrgGeneralSettings {...commonProps} />;
            case 'org-branding':
                return <OrgBrandingSettings {...commonProps} />;
            case 'members':
                return <OrgMembersSettings {...commonProps} />;
            case 'subscription':
            case 'billing':
                return <SubscriptionSettings {...commonProps} />;
            case 'workspace-general':
                return <WorkspaceGeneralSettings {...commonProps} />;
            case 'invite-clients':
                return <InviteClientsSettings {...commonProps} />;
            default:
                return <ProfileSettings {...commonProps} />;
        }
    };

    const handleMenuItemSelect = (menuKey) => {
        setSelectedMenuItem(menuKey);
    };

    return (
        <div className="wrapper settings-wrapper">
            {loading ? (
                <LoadingScreen />
            ) : (
                error ? (
                    <ErrorHandler errorCode={error} />
                ) : (
                    <div className="settings-page">  
                       <div className="settings-content">
                        {renderSettingsContent()}
                       </div>
                       <SettingsMenu 
                           className="settings-menu"
                           onMenuItemSelect={handleMenuItemSelect}
                           selectedMenuItem={selectedMenuItem}
                       />
                    </div>
                )
            )}
        </div>
    );
};

export default Settings;
